import "./App.css";
import Footer from "./components/layouts/footer";
import Navbar from "./components/layouts/navbar";

function App() {
  return (
    <div className="App">
      <Navbar />
      <Footer />
    </div>
  );
}

export default App;
